import * as React from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@payscale/design';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import './cyclePublishedAlert.scss';

interface ICyclePublishedAlertProps {
    hasHrOrSupportRole: boolean;
    exportAllManagersToCsv: () => void;
    configuration: Configuration;
}

export class CyclePublishedAlert extends React.Component<ICyclePublishedAlertProps> {
    render(): React.ReactNode {
        const { configuration } = this.props;
        if (!configuration.isPublished) {
            return null;
        }

        return (
            <Alert
                className="nomst-cycle-published-alert"
                message={this.renderCyclePublishedMessage()}
                level="success"
                close={false}
            />
        );
    }

    renderCyclePublishedMessage(): React.ReactNode {
        return (
            <div className="nomst-cycle-published-alert__message">
                <strong>{this.getCyclePublishedAlertTitle()}</strong>
                {this.renderCyclePublishedDescription()}
            </div>
        );
    }

    renderCyclePublishedDescription(): React.ReactNode {
        const { exportAllManagersToCsv, hasHrOrSupportRole } = this.props;
        if (hasHrOrSupportRole) {
            return (
                <p className="nomst-cycle-published-alert__description">
                    This
                    <button className="pxl-link" onClick={exportAllManagersToCsv}>
                        full export of pay decisions
                    </button>
                    can be used to update your HRIS/payroll system.
                </p>
            );
        }

        return (
            <p className="nomst-cycle-published-alert__description">
                Your recommendations are now reflected in employee&apos;s current pay.
            </p>
        );
    }

    getCyclePublishedAlertTitle(): string {
        return this.props.hasHrOrSupportRole ?
            'Hooray! You\'ve completed the cycle.' :
            'This cycle was closed.';
    }
}

export default observer(CyclePublishedAlert);